const state = {
  preferredPaymentSourceUid: '',
}

const getters = {}

const actions = {}

const mutations = {
  SET_PREFERRED_PAYMENT_SOURCE_UID(state, uid) {
    state.preferredPaymentSourceUid =
      state.preferredPaymentSourceUid === uid ? '' : uid
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}
